module.exports = __webpack_public_path__ + "static/img/pdd2.316bc661.png";